import React from "react";

export default function Success({ message }) {
  return (
    <div className="w-full text-center mt-1 py-1 text-green-700 bg-green-300 ">
      {message}
    </div>
  );
}
